import { createSlice } from '@reduxjs/toolkit'

export const loadingReducer = createSlice({
  name: 'loading',
  initialState:{
    value:false
  },
  reducers: {
    isloading: (state) => {
      state.value = !state.value
    },
   
  },
})

export const { isloading } = loadingReducer.actions

export default loadingReducer.reducer